function _extends() {
  _extends =
    Object.assign ||
    function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
const BugIcon = forwardRef(function(_ref, ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    rest = _objectWithoutProperties(_ref, ['color', 'size']);

  return /*#__PURE__*/ React.createElement(
    'svg',
    _extends(
      {
        ref: ref,
        width: size,
        height: size,
        viewBox: '0 0 12 12',
        fill: color,
        xmlns: 'http://www.w3.org/2000/svg',
        stroke: "none",
      },
      rest
    ),
    /*#__PURE__*/ React.createElement('path', {
      d:
        'M10.2 7.2H11.4C11.5591 7.2 11.7117 7.13679 11.8243 7.02426C11.9368 6.91174 12 6.75913 12 6.6C12 6.44087 11.9368 6.28826 11.8243 6.17574C11.7117 6.06321 11.5591 6 11.4 6H10.2V5.4C10.1947 5.12359 10.1523 4.84914 10.074 4.584C10.638 4.36777 11.1236 3.98634 11.4672 3.48962C11.8108 2.99289 11.9965 2.404 12 1.8C12 1.64087 11.9368 1.48826 11.8243 1.37574C11.7117 1.26321 11.5591 1.2 11.4 1.2C11.2409 1.2 11.0883 1.26321 10.9757 1.37574C10.8632 1.48826 10.8 1.64087 10.8 1.8C10.7995 2.18691 10.6743 2.56335 10.443 2.87352C10.2117 3.18369 9.88667 3.41109 9.516 3.522C9.22009 3.14278 8.83733 2.84028 8.4 2.64C8.40621 2.56012 8.40621 2.47988 8.4 2.4C8.4 1.76348 8.14714 1.15303 7.69706 0.702944C7.24697 0.252856 6.63652 0 6 0C5.36348 0 4.75303 0.252856 4.30294 0.702944C3.85286 1.15303 3.6 1.76348 3.6 2.4C3.59379 2.47988 3.59379 2.56012 3.6 2.64C3.15397 2.83699 2.76268 3.13973 2.46 3.522C2.09381 3.40684 1.77402 3.17762 1.54734 2.86783C1.32066 2.55803 1.19895 2.18387 1.2 1.8C1.2 1.64087 1.13679 1.48826 1.02426 1.37574C0.911742 1.26321 0.75913 1.2 0.6 1.2C0.44087 1.2 0.288258 1.26321 0.175736 1.37574C0.0632141 1.48826 0 1.64087 0 1.8C0.00345969 2.404 0.189159 2.99289 0.5328 3.48962C0.876441 3.98634 1.36202 4.36777 1.926 4.584C1.84769 4.84914 1.80531 5.12359 1.8 5.4V6H0.6C0.44087 6 0.288258 6.06321 0.175736 6.17574C0.0632141 6.28826 0 6.44087 0 6.6C0 6.75913 0.0632141 6.91174 0.175736 7.02426C0.288258 7.13679 0.44087 7.2 0.6 7.2H1.8V7.8C1.80052 8.0781 1.82866 8.35546 1.884 8.628C1.32977 8.85011 0.854421 9.23255 0.518794 9.72637C0.183167 10.2202 0.00252942 10.8029 0 11.4C0 11.5591 0.0632141 11.7117 0.175736 11.8243C0.288258 11.9368 0.44087 12 0.6 12C0.75913 12 0.911742 11.9368 1.02426 11.8243C1.13679 11.7117 1.2 11.5591 1.2 11.4C1.20162 11.0501 1.30521 10.7082 1.49809 10.4162C1.69097 10.1242 1.96477 9.8948 2.286 9.756C2.64282 10.4317 3.17724 10.9973 3.8317 11.3918C4.48615 11.7863 5.23584 11.9948 6 11.9948C6.76416 11.9948 7.51385 11.7863 8.1683 11.3918C8.82276 10.9973 9.35718 10.4317 9.714 9.756C10.0352 9.8948 10.309 10.1242 10.5019 10.4162C10.6948 10.7082 10.7984 11.0501 10.8 11.4C10.8 11.5591 10.8632 11.7117 10.9757 11.8243C11.0883 11.9368 11.2409 12 11.4 12C11.5591 12 11.7117 11.9368 11.8243 11.8243C11.9368 11.7117 12 11.5591 12 11.4C11.9975 10.8029 11.8168 10.2202 11.4812 9.72637C11.1456 9.23255 10.6702 8.85011 10.116 8.628C10.1713 8.35546 10.1995 8.0781 10.2 7.8V7.2ZM5.4 10.74C4.72238 10.6017 4.11336 10.2335 3.67602 9.69774C3.23867 9.16199 2.99986 8.49159 3 7.8V5.4C3 4.92261 3.18964 4.46477 3.52721 4.12721C3.86477 3.78964 4.32261 3.6 4.8 3.6H5.4V10.74ZM4.8 2.4C4.8 2.08174 4.92643 1.77652 5.15147 1.55147C5.37652 1.32643 5.68174 1.2 6 1.2C6.31826 1.2 6.62348 1.32643 6.84853 1.55147C7.07357 1.77652 7.2 2.08174 7.2 2.4H4.8ZM9 7.8C9.00014 8.49159 8.76133 9.16199 8.32398 9.69774C7.88664 10.2335 7.27762 10.6017 6.6 10.74V3.6H7.2C7.67739 3.6 8.13523 3.78964 8.47279 4.12721C8.81036 4.46477 9 4.92261 9 5.4V7.8Z',
    })
  );
});
BugIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
BugIcon.displayName = 'BugIcon';
export default BugIcon;
